module.exports = __webpack_public_path__ + "static/media/bn_2.420249c7.png";